export default __webpack_public_path__ + "media/zurb/fonts/ProximaNova-Semibold-5e45c8b261431258c7396f53cbe15894.woff2";